import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Modal from 'react-bootstrap/Modal';
import Card from 'react-bootstrap/Card';
import Badge from 'react-bootstrap/Badge';
import axios from 'axios';
import '../App.css'; 
import './Rapports.css'; 
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { AddRapportsTwin } from '../Redux/Actions/RapportTwinAction';
import { current } from "../Redux/Actions/AuthActions";

const RapportsTwin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(current());
  }, [dispatch]);

  const user = useSelector((state) => state.AuthReducer.user);
  
  // Emplacements dynamiques
  const [locations, setLocations] = useState([]);
  const [emplacement, setEmplacement] = useState('');
  const [selectedLocationObj, setSelectedLocationObj] = useState(null);

  const ORIGINAL_TWIN_PARKS = [
    "Twin Park - Tunisia Mall",
    "Twin Park- Manar City",
    "Twin park - Jardins d'eL Menzah",
    "Jump Zone Mall of Djerba"
  ];

  // Charger les emplacements Twin Park depuis le serveur (Strictement les 4 parcs d'origine)
  const fetchLocations = async () => {
    try {
      const res = await axios.get('/api/Locations/getAllLocations');
      const data = Array.isArray(res.data) ? res.data : [];
      
      // Filtrer STRICTEMENT les parcs d'origine Twin Park
      const twinLocs = data.filter((l) => ORIGINAL_TWIN_PARKS.includes(l.name));
      
      const finalLocs = twinLocs.length > 0
        ? twinLocs
        : ORIGINAL_TWIN_PARKS.map(name => ({ _id: name, name, category: 'Twin Park' }));

      setLocations(finalLocs);

      // Définir l'emplacement par défaut
      if (finalLocs.length > 0 && !emplacement) {
        if (user?.localisation && finalLocs.some((l) => l.name === user.localisation)) {
          setEmplacement(user.localisation);
        } else {
          setEmplacement(finalLocs[0].name);
        }
      }
    } catch (err) {
      console.error("Erreur lors du chargement des emplacements Twin Park :", err);
      const fallback = ORIGINAL_TWIN_PARKS.map(name => ({ _id: name, name, category: 'Twin Park' }));
      setLocations(fallback);
      setEmplacement(fallback[0].name);
    }
  };

  useEffect(() => {
    fetchLocations();
  }, [user]);

  // Mettre à jour les voitures du parc quand l'emplacement change
  const [dynamicCarRaceState, setDynamicCarRaceState] = useState({});

  useEffect(() => {
    if (emplacement && locations.length > 0) {
      const found = locations.find((l) => l.name === emplacement);
      setSelectedLocationObj(found || null);

      if (found && found.carRaceProducts && found.carRaceProducts.length > 0) {
        const initialState = {};
        found.carRaceProducts.forEach((car) => {
          initialState[car.name] = { cash: 0, tpe: 0, color: car.color || '#3b82f6' };
        });
        setDynamicCarRaceState(initialState);
      } else {
        setDynamicCarRaceState({});
      }
    }
  }, [emplacement, locations]);

  const [date, setDate] = useState(new Date().toISOString().split('T')[0]);

  // 🏰 1. PlayZone & Accès
  const [playZoneStandardCash, setPlayZoneStandardCash] = useState(0);
  const [playZoneStandardTpe, setPlayZoneStandardTpe] = useState(0);
  const [playZoneSurveilléCash, setPlayZoneSurveilléCash] = useState(0);
  const [playZoneSurveilléTpe, setPlayZoneSurveilléTpe] = useState(0);
  const [playZoneKidsCash, setPlayZoneKidsCash] = useState(0);
  const [playZoneKidsTpe, setPlayZoneKidsTpe] = useState(0);
  const [accesParentCash, setAccesParentCash] = useState(0);
  const [accesParentTpe, setAccesParentTpe] = useState(0);

  // 💳 3. Cartes & Pass
  const [packQRCash, setPackQRCash] = useState(0);
  const [packQRTpe, setPackQRTpe] = useState(0);
  const [rechargeQRCash, setRechargeQRCash] = useState(0);
  const [rechargeQRTpe, setRechargeQRTpe] = useState(0);
  const [packCardCash, setPackCardCash] = useState(0);
  const [packCardTpe, setPackCardTpe] = useState(0);
  const [rechargeCardCash, setRechargeCardCash] = useState(0);
  const [rechargeCardTpe, setRechargeCardTpe] = useState(0);

  // 🛍️ 4. Boutique & Jeux
  const [twinClubCash, setTwinClubCash] = useState(0);
  const [twinClubTpe, setTwinClubTpe] = useState(0);
  const [twinToysCash, setTwinToysCash] = useState(0);
  const [twinToysTpe, setTwinToysTpe] = useState(0);
  const [challengeGamesCash, setChallengeGamesCash] = useState(0);
  const [challengeGamesTpe, setChallengeGamesTpe] = useState(0);
  const [candyBarCash, setCandyBarCash] = useState(0);
  const [candyBarTpe, setCandyBarTpe] = useState(0);

  // 🎉 5. Événements
  const [packAnnifCash, setPackAnnifCash] = useState(0);
  const [packAnnifTpe, setPackAnnifTpe] = useState(0);

  // 💸 Dépenses
  const [taxiExpense, setTaxiExpense] = useState(0);
  const [repairExpense, setRepairExpense] = useState(0);
  const [advanceExpense, setAdvanceExpense] = useState(0);
  const [miscExpense, setMiscExpense] = useState(0);
  const [otherExpense, setOtherExpense] = useState(0);
  
  const [explanation, setExplanation] = useState('');
  const [showTpeModal, setShowTpeModal] = useState(false);

  const handleCloseTpeModal = () => setShowTpeModal(false);
  const handleShowTpeModal = () => setShowTpeModal(true);

  // Mise à jour de la valeur d'une voiture dynamique
  const handleCarRaceValueChange = (carName, field, value) => {
    if (/^\d*\.?\d{0,3}$/.test(value)) {
      setDynamicCarRaceState((prev) => ({
        ...prev,
        [carName]: {
          ...prev[carName],
          [field]: value
        }
      }));
    }
  };

  // 🧮 Calcul des voitures dynamiques
  const calculateDynamicCarRaceTotal = () => {
    return Object.values(dynamicCarRaceState).reduce((acc, car) => {
      return acc + parseFloat(car.cash || 0) + parseFloat(car.tpe || 0);
    }, 0);
  };

  const calculateDynamicCarRaceTpeTotal = () => {
    return Object.values(dynamicCarRaceState).reduce((acc, car) => {
      return acc + parseFloat(car.tpe || 0);
    }, 0);
  };

  // 🧮 Calculs des montants totaux
  const calculateTotalAmount = () => {
    const fixedTotal = (
      parseFloat(playZoneStandardCash || 0) + parseFloat(playZoneStandardTpe || 0) +
      parseFloat(playZoneSurveilléCash || 0) + parseFloat(playZoneSurveilléTpe || 0) +
      parseFloat(playZoneKidsCash || 0) + parseFloat(playZoneKidsTpe || 0) +
      parseFloat(accesParentCash || 0) + parseFloat(accesParentTpe || 0) +

      parseFloat(packQRCash || 0) + parseFloat(packQRTpe || 0) +
      parseFloat(rechargeQRCash || 0) + parseFloat(rechargeQRTpe || 0) +
      parseFloat(packCardCash || 0) + parseFloat(packCardTpe || 0) +
      parseFloat(rechargeCardCash || 0) + parseFloat(rechargeCardTpe || 0) +
      parseFloat(twinClubCash || 0) + parseFloat(twinClubTpe || 0) +
      parseFloat(twinToysCash || 0) + parseFloat(twinToysTpe || 0) +
      parseFloat(challengeGamesCash || 0) + parseFloat(challengeGamesTpe || 0) +
      parseFloat(candyBarCash || 0) + parseFloat(candyBarTpe || 0) +
      parseFloat(packAnnifCash || 0) + parseFloat(packAnnifTpe || 0)
    );
    return (fixedTotal + calculateDynamicCarRaceTotal()).toFixed(3);
  };

  const calculateTotalTPE = () => {
    const fixedTpe = (
      parseFloat(playZoneStandardTpe || 0) +
      parseFloat(playZoneSurveilléTpe || 0) +
      parseFloat(playZoneKidsTpe || 0) +
      parseFloat(accesParentTpe || 0) +
      parseFloat(packQRTpe || 0) +
      parseFloat(rechargeQRTpe || 0) +
      parseFloat(packCardTpe || 0) +
      parseFloat(rechargeCardTpe || 0) +
      parseFloat(twinClubTpe || 0) +
      parseFloat(twinToysTpe || 0) +
      parseFloat(challengeGamesTpe || 0) +
      parseFloat(candyBarTpe || 0) +
      parseFloat(packAnnifTpe || 0)
    );
    return (fixedTpe + calculateDynamicCarRaceTpeTotal()).toFixed(3);
  };

  const calculateTotalExpenses = () => {
    return (
      parseFloat(taxiExpense || 0) +
      parseFloat(repairExpense || 0) +
      parseFloat(advanceExpense || 0) +
      parseFloat(miscExpense || 0) +
      parseFloat(otherExpense || 0)
    ).toFixed(3);
  };

  const handleNumberInput = (e, setState) => {
    const value = e.target.value;
    if (/^\d*\.?\d{0,3}$/.test(value)) {
      setState(value);
    }
  };

  const existingReports = useSelector((state) => state.RapportTwinReducer.rapportsTwin || []);

  const handleRapportTwin = (e) => {
      e.preventDefault();
  
      if (!emplacement || !date || !explanation) {
          alert("Veuillez remplir tous les champs obligatoires (emplacement, date, explication).");
          return;
      }
  
      const duplicateReport = existingReports.find(
          (report) =>
              report.localisation === emplacement &&
              report.DateCollect === date
      );
  
      if (duplicateReport) {
          alert("Un rapport pour cette localisation et cette date existe déjà.");
          return;
      }
  
      const confirmSubmit = window.confirm("Voulez-vous confirmer les informations saisies ?");
      if (!confirmSubmit) {
          return;
      }

      // Préparer les détails des voitures
      const carRaceDetails = Object.entries(dynamicCarRaceState).map(([carName, carVal]) => ({
        name: carName,
        color: carVal.color || '#3b82f6',
        cash: parseFloat(carVal.cash || 0),
        tpe: parseFloat(carVal.tpe || 0),
        amount: parseFloat(carVal.cash || 0) + parseFloat(carVal.tpe || 0)
      }));
  
      const rapportData = {
          DateCollect: date.slice(0, 10),
          localisation: emplacement,
          PlayZoneStandard: parseFloat(playZoneStandardCash || 0) + parseFloat(playZoneStandardTpe || 0),
          PlayZoneSurveillé: parseFloat(playZoneSurveilléCash || 0) + parseFloat(playZoneSurveilléTpe || 0),
          PlayZoneKids: parseFloat(playZoneKidsCash || 0) + parseFloat(playZoneKidsTpe || 0),
          AccesParent: parseFloat(accesParentCash || 0) + parseFloat(accesParentTpe || 0),
          
          // Car Race standards (Tunisia Mall ou secours)
          CarRaceJaune: parseFloat(dynamicCarRaceState["Jaune"]?.cash || 0) + parseFloat(dynamicCarRaceState["Jaune"]?.tpe || 0),
          CarRaceNoir: parseFloat(dynamicCarRaceState["Noir"]?.cash || 0) + parseFloat(dynamicCarRaceState["Noir"]?.tpe || 0),
          CarRaceRougeS: parseFloat(dynamicCarRaceState["Rouge S"]?.cash || 0) + parseFloat(dynamicCarRaceState["Rouge S"]?.tpe || 0),
          CarRaceRougeB: parseFloat(dynamicCarRaceState["Rouge B"]?.cash || 0) + parseFloat(dynamicCarRaceState["Rouge B"]?.tpe || 0),

          // Car Race dynamique par emplacement
          carRaceDetails: carRaceDetails,

          PackQR: parseFloat(packQRCash || 0) + parseFloat(packQRTpe || 0),
          RechargeQR: parseFloat(rechargeQRCash || 0) + parseFloat(rechargeQRTpe || 0),
          PackCard: parseFloat(packCardCash || 0) + parseFloat(packCardTpe || 0),
          RechargeCard: parseFloat(rechargeCardCash || 0) + parseFloat(rechargeCardTpe || 0),
          TwinClub: parseFloat(twinClubCash || 0) + parseFloat(twinClubTpe || 0),
          TwinToys: parseFloat(twinToysCash || 0) + parseFloat(twinToysTpe || 0),
          ChallengeGames: parseFloat(challengeGamesCash || 0) + parseFloat(challengeGamesTpe || 0),
          CandyBar: parseFloat(candyBarCash || 0) + parseFloat(candyBarTpe || 0),
          PackAnnif: parseFloat(packAnnifCash || 0) + parseFloat(packAnnifTpe || 0),
          TotalAmount: parseFloat(calculateTotalAmount()),
          TotalTpe: parseFloat(calculateTotalTPE()),
          DailyExpenses: parseFloat(calculateTotalExpenses()),
          TaxiExpenses: parseFloat(taxiExpense || 0),
          RepairExpenses: parseFloat(repairExpense || 0),
          StaffAdvance: parseFloat(advanceExpense || 0),
          MiscPurchases: parseFloat(miscExpense || 0),
          OtherExpenses: parseFloat(otherExpense || 0),
          feedback: explanation,
          owner: user._id,
      };
  
      dispatch(AddRapportsTwin(rapportData, navigate));
  };

  return (
    <div className="list-rapports container my-4" style={{ marginTop: '95px' }}>   
      <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-2">
        <div>
          <h3 className="fw-bold text-primary mb-1">📝 Rapport Quotidien Twin Park</h3>
          <p className="text-muted mb-0 small">Saisie des recettes et dépenses de la journée</p>
        </div>

        <div>
          <Badge bg="primary" className="p-2 fs-6">Saisie Caissière</Badge>
        </div>
      </div>

      <Form className="rapport-form" onSubmit={handleRapportTwin}>
        {/* Entête Emplacement et Date - Style Bleu Lumineux */}
        <Card className="mb-4 shadow-sm border-primary border-2 bg-light p-3">
          <Row className="g-3">
            <Form.Group as={Col} md={6} controlId="formGridState">
              <Form.Label className="fw-bold text-primary">📍 Emplacement du Parc</Form.Label>
              <Form.Select 
                onChange={(e) => setEmplacement(e.target.value)} 
                className="fw-bold border-primary text-dark" 
                value={emplacement}>
                {locations.length > 0 ? (
                  locations.map((loc) => (
                    <option key={loc._id} value={loc.name}>
                      {loc.name}
                    </option>
                  ))
                ) : (
                  <>
                    <option>Twin Park - Tunisia Mall</option>
                    <option>Twin Park- Manar City</option>
                    <option>Twin park - Jardins d'eL Menzah</option>
                    <option>Jump Zone Mall of Djerba</option>
                  </>
                )}
              </Form.Select>
            </Form.Group>
              
            <Form.Group as={Col} md={6} controlId="formGridDate">
              <Form.Label className="fw-bold text-primary">📅 Date du Jour</Form.Label>
              <Form.Control 
                type="date" 
                className="fw-bold border-primary text-dark" 
                value={date} 
                onChange={(e) => setDate(e.target.value)}
                readOnly={user?.role !== 'admin'}
              />
            </Form.Group>
          </Row>
        </Card>

        {/* Header Recettes et Bouton Modal TPE */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4 className="fw-bold text-primary mb-0">💵 Recettes (Espèces & TPE)</h4>
          <Button onClick={handleShowTpeModal} variant="primary" className="fw-bold shadow-sm">
            💳 Saisir les Paiements par Carte (TPE)
          </Button>
        </div>

        {/* 🏰 CATEGORIE 1: PLAYZONE & ACCÈS */}
        <Card className="mb-4 shadow-sm border-0">
          <Card.Header className="bg-primary text-white fw-bold fs-6">
            🏰 1. PlayZone & Accès
          </Card.Header>
          <Card.Body className="bg-white">
            <Row className="g-3">
              <Form.Group as={Col} md={3} controlId="formPlayZoneStandard">
                <Form.Label className="fw-semibold text-dark">PlayZone Standard</Form.Label>
                <Form.Control 
                  type="text" 
                  value={playZoneStandardCash}
                  onChange={(e) => handleNumberInput(e, setPlayZoneStandardCash)}
                  placeholder="Espèces (DT)" 
                />
              </Form.Group>

              <Form.Group as={Col} md={3} controlId="formPlayZoneSurveillé">
                <Form.Label className="fw-semibold text-dark">PlayZone Surveillé</Form.Label>
                <Form.Control 
                  type="text" 
                  value={playZoneSurveilléCash}
                  onChange={(e) => handleNumberInput(e, setPlayZoneSurveilléCash)}
                  placeholder="Espèces (DT)" 
                />
              </Form.Group>

              <Form.Group as={Col} md={3} controlId="formPlayZoneKids">
                <Form.Label className="fw-bold" style={{ color: '#7c3aed' }}>PlayZone Kids 🎈</Form.Label>
                <Form.Control 
                  type="text" 
                  value={playZoneKidsCash}
                  onChange={(e) => handleNumberInput(e, setPlayZoneKidsCash)}
                  placeholder="Espèces (DT)" 
                />
              </Form.Group>

              <Form.Group as={Col} md={3} controlId="formAccesParent">
                <Form.Label className="fw-semibold text-dark">Accès Parents</Form.Label>
                <Form.Control 
                  type="text" 
                  value={accesParentCash}
                  onChange={(e) => handleNumberInput(e, setAccesParentCash)}
                  placeholder="Espèces (DT)" 
                />
              </Form.Group>
            </Row>
          </Card.Body>
        </Card>

        {/* 🏎️ CATEGORIE 2: CAR RACE (VOITURES SPÉCIFIQUES PAR PARC) */}
        <Card className="mb-4 shadow-sm border-warning">
          <Card.Header className="bg-warning text-dark fw-bold fs-6 d-flex justify-content-between align-items-center">
            <span>🏎️ 2. Car Race (Voitures du parc : {emplacement})</span>
            <Badge bg="dark">Spécifique à ce parc</Badge>
          </Card.Header>
          <Card.Body className="bg-white">
            {Object.keys(dynamicCarRaceState).length > 0 ? (
              <Row className="g-3">
                {Object.entries(dynamicCarRaceState).map(([carName, carVal]) => (
                  <Form.Group as={Col} md={3} key={carName}>
                    <Form.Label className="fw-bold" style={{ color: carVal.color || '#d97706' }}>
                      🏎️ Car Race - {carName}
                    </Form.Label>
                    <Form.Control 
                      type="text" 
                      value={carVal.cash || 0}
                      onChange={(e) => handleCarRaceValueChange(carName, 'cash', e.target.value)}
                      placeholder="Espèces (DT)" 
                    />
                  </Form.Group>
                ))}
              </Row>
            ) : (
              <p className="text-muted mb-0 small">
                Aucune voiture configurée pour ce parc. (L'administrateur peut en ajouter via "Gérer Emplacements & Voitures").
              </p>
            )}
          </Card.Body>
        </Card>

        {/* 💳 CATEGORIE 3: CARTES & PASS */}
        <Card className="mb-4 shadow-sm border-0">
          <Card.Header className="bg-primary text-white fw-bold fs-6">
            💳 3. Cartes & Pass (QR / Card)
          </Card.Header>
          <Card.Body className="bg-white">
            <Row className="g-3">
              <Form.Group as={Col} md={3} controlId="formPackQR">
                <Form.Label className="fw-semibold text-dark">Pack QR</Form.Label>
                <Form.Control 
                  type="text" 
                  value={packQRCash}
                  onChange={(e) => handleNumberInput(e, setPackQRCash)}
                  placeholder="Espèces (DT)" 
                />
              </Form.Group>

              <Form.Group as={Col} md={3} controlId="formRechargeQR">
                <Form.Label className="fw-semibold text-dark">Recharge QR</Form.Label>
                <Form.Control 
                  type="text" 
                  value={rechargeQRCash}
                  onChange={(e) => handleNumberInput(e, setRechargeQRCash)}
                  placeholder="Espèces (DT)" 
                />
              </Form.Group>

              <Form.Group as={Col} md={3} controlId="formPackCard">
                <Form.Label className="fw-semibold text-dark">Pack Card</Form.Label>
                <Form.Control 
                  type="text" 
                  value={packCardCash}
                  onChange={(e) => handleNumberInput(e, setPackCardCash)}
                  placeholder="Espèces (DT)" 
                />
              </Form.Group>

              <Form.Group as={Col} md={3} controlId="formRechargeCard">
                <Form.Label className="fw-semibold text-dark">Recharge Card</Form.Label>
                <Form.Control 
                  type="text" 
                  value={rechargeCardCash}
                  onChange={(e) => handleNumberInput(e, setRechargeCardCash)}
                  placeholder="Espèces (DT)" 
                />
              </Form.Group>
            </Row>
          </Card.Body>
        </Card>

        {/* 🛍️ CATEGORIE 4: BOUTIQUE & JEUX */}
        <Card className="mb-4 shadow-sm border-0">
          <Card.Header className="bg-primary text-white fw-bold fs-6">
            🛍️ 4. Boutique & Jeux
          </Card.Header>
          <Card.Body className="bg-white">
            <Row className="g-3">
              <Form.Group as={Col} md={3} controlId="formTwinToys">
                <Form.Label className="fw-semibold text-dark">Twin Toys</Form.Label>
                <Form.Control 
                  type="text" 
                  value={twinToysCash}
                  onChange={(e) => handleNumberInput(e, setTwinToysCash)}
                  placeholder="Espèces (DT)" 
                />
              </Form.Group>

              <Form.Group as={Col} md={3} controlId="formTwinClub">
                <Form.Label className="fw-semibold text-dark">Twin Club</Form.Label>
                <Form.Control 
                  type="text" 
                  value={twinClubCash}
                  onChange={(e) => handleNumberInput(e, setTwinClubCash)}
                  placeholder="Espèces (DT)" 
                />
              </Form.Group>

              <Form.Group as={Col} md={3} controlId="formChallengeGames">
                <Form.Label className="fw-semibold text-dark">Challenge Games</Form.Label>
                <Form.Control 
                  type="text" 
                  value={challengeGamesCash}
                  onChange={(e) => handleNumberInput(e, setChallengeGamesCash)}
                  placeholder="Espèces (DT)" 
                />
              </Form.Group>

              <Form.Group as={Col} md={3} controlId="formCandyBar">
                <Form.Label className="fw-semibold text-dark">Candy Bar</Form.Label>
                <Form.Control 
                  type="text" 
                  value={candyBarCash}
                  onChange={(e) => handleNumberInput(e, setCandyBarCash)}
                  placeholder="Espèces (DT)" 
                />
              </Form.Group>
            </Row>
          </Card.Body>
        </Card>

        {/* 🎉 CATEGORIE 5: ÉVÉNEMENTS */}
        <Card className="mb-4 shadow-sm border-0">
          <Card.Header className="bg-primary text-white fw-bold fs-6">
            🎉 5. Événements
          </Card.Header>
          <Card.Body className="bg-white">
            <Row className="g-3">
              <Form.Group as={Col} md={6} controlId="formPackAnnif">
                <Form.Label className="fw-semibold text-dark">Pack Anniversaire</Form.Label>
                <Form.Control 
                  type="text" 
                  value={packAnnifCash}
                  onChange={(e) => handleNumberInput(e, setPackAnnifCash)}
                  placeholder="Espèces (DT)" 
                />
              </Form.Group>
            </Row>
          </Card.Body>
        </Card>

        {/* 💳 Modal pour les paiements TPE */}
        <Modal show={showTpeModal} onHide={handleCloseTpeModal} size="lg" centered>
          <Modal.Header closeButton className="bg-primary text-white">
            <Modal.Title className="fs-5">💳 Saisie des Paiements par TPE (Carte)</Modal.Title>
          </Modal.Header>
          <Modal.Body className="bg-white">
            <p className="text-primary mb-3 small fw-bold">Entrez les montants réglés par Carte / TPE.</p>

            <h6 className="text-primary fw-bold border-bottom pb-2">🏰 PlayZone & Accès (TPE)</h6>
            <Row className="mb-3">
              <Form.Group as={Col} md={3}>
                <Form.Label className="small">PlayZone Standard</Form.Label>
                <Form.Control type="text" value={playZoneStandardTpe} onChange={(e) => handleNumberInput(e, setPlayZoneStandardTpe)} placeholder="0.000 DT" />
              </Form.Group>
              <Form.Group as={Col} md={3}>
                <Form.Label className="small">PlayZone Surveillé</Form.Label>
                <Form.Control type="text" value={playZoneSurveilléTpe} onChange={(e) => handleNumberInput(e, setPlayZoneSurveilléTpe)} placeholder="0.000 DT" />
              </Form.Group>
              <Form.Group as={Col} md={3}>
                <Form.Label className="small fw-bold" style={{ color: '#7c3aed' }}>PlayZone Kids 🎈</Form.Label>
                <Form.Control type="text" value={playZoneKidsTpe} onChange={(e) => handleNumberInput(e, setPlayZoneKidsTpe)} placeholder="0.000 DT" />
              </Form.Group>
              <Form.Group as={Col} md={3}>
                <Form.Label className="small">Accès Parents</Form.Label>
                <Form.Control type="text" value={accesParentTpe} onChange={(e) => handleNumberInput(e, setAccesParentTpe)} placeholder="0.000 DT" />
              </Form.Group>
            </Row>

            <h6 className="text-warning fw-bold border-bottom pb-2">🏎️ Car Race (TPE - {emplacement})</h6>
            <Row className="mb-3">
              {Object.entries(dynamicCarRaceState).map(([carName, carVal]) => (
                <Form.Group as={Col} md={3} key={carName} className="mb-2">
                  <Form.Label className="small fw-bold" style={{ color: carVal.color || '#d97706' }}>
                    🏎️ {carName}
                  </Form.Label>
                  <Form.Control 
                    type="text" 
                    value={carVal.tpe || 0} 
                    onChange={(e) => handleCarRaceValueChange(carName, 'tpe', e.target.value)} 
                    placeholder="0.000 DT" 
                  />
                </Form.Group>
              ))}
            </Row>

            <h6 className="text-primary fw-bold border-bottom pb-2">💳 Cartes & Pass (TPE)</h6>
            <Row className="mb-3">
              <Form.Group as={Col} md={3}>
                <Form.Label className="small">Pack QR</Form.Label>
                <Form.Control type="text" value={packQRTpe} onChange={(e) => handleNumberInput(e, setPackQRTpe)} placeholder="0.000 DT" />
              </Form.Group>
              <Form.Group as={Col} md={3}>
                <Form.Label className="small">Recharge QR</Form.Label>
                <Form.Control type="text" value={rechargeQRTpe} onChange={(e) => handleNumberInput(e, setRechargeQRTpe)} placeholder="0.000 DT" />
              </Form.Group>
              <Form.Group as={Col} md={3}>
                <Form.Label className="small">Pack Card</Form.Label>
                <Form.Control type="text" value={packCardTpe} onChange={(e) => handleNumberInput(e, setPackCardTpe)} placeholder="0.000 DT" />
              </Form.Group>
              <Form.Group as={Col} md={3}>
                <Form.Label className="small">Recharge Card</Form.Label>
                <Form.Control type="text" value={rechargeCardTpe} onChange={(e) => handleNumberInput(e, setRechargeCardTpe)} placeholder="0.000 DT" />
              </Form.Group>
            </Row>

            <h6 className="text-primary fw-bold border-bottom pb-2">🛍️ Boutique, Jeux & Événements (TPE)</h6>
            <Row className="mb-3">
              <Form.Group as={Col} md={3}>
                <Form.Label className="small">Twin Toys</Form.Label>
                <Form.Control type="text" value={twinToysTpe} onChange={(e) => handleNumberInput(e, setTwinToysTpe)} placeholder="0.000 DT" />
              </Form.Group>
              <Form.Group as={Col} md={3}>
                <Form.Label className="small">Twin Club</Form.Label>
                <Form.Control type="text" value={twinClubTpe} onChange={(e) => handleNumberInput(e, setTwinClubTpe)} placeholder="0.000 DT" />
              </Form.Group>
              <Form.Group as={Col} md={3}>
                <Form.Label className="small">Challenge Games</Form.Label>
                <Form.Control type="text" value={challengeGamesTpe} onChange={(e) => handleNumberInput(e, setChallengeGamesTpe)} placeholder="0.000 DT" />
              </Form.Group>
              <Form.Group as={Col} md={3}>
                <Form.Label className="small">Candy Bar</Form.Label>
                <Form.Control type="text" value={candyBarTpe} onChange={(e) => handleNumberInput(e, setCandyBarTpe)} placeholder="0.000 DT" />
              </Form.Group>
              <Form.Group as={Col} md={3} className="mt-2">
                <Form.Label className="small">Pack Anniversaire</Form.Label>
                <Form.Control type="text" value={packAnnifTpe} onChange={(e) => handleNumberInput(e, setPackAnnifTpe)} placeholder="0.000 DT" />
              </Form.Group>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={handleCloseTpeModal} className="fw-bold">
              Confirmer les montants TPE
            </Button>
          </Modal.Footer>
        </Modal>

        {/* 💸 SECTION DÉPENSES */}
        <Card className="mb-4 shadow-sm border-danger">
          <Card.Header className="bg-danger text-white fw-bold fs-6">
            💸 Dépenses Détaillées de la journée
          </Card.Header>
          <Card.Body className="bg-white">
            <Row className="g-3 mb-2">
              <Form.Group as={Col} md={4}>
                <Form.Label className="fw-semibold text-dark">Frais de Taxi</Form.Label>
                <Form.Control 
                  type="text" 
                  value={taxiExpense}
                  onChange={(e) => handleNumberInput(e, setTaxiExpense)}
                  placeholder="0.000 DT" 
                />
              </Form.Group>

              <Form.Group as={Col} md={4}>
                <Form.Label className="fw-semibold text-dark">Frais de Réparation</Form.Label>
                <Form.Control 
                  type="text" 
                  value={repairExpense}
                  onChange={(e) => handleNumberInput(e, setRepairExpense)}
                  placeholder="0.000 DT" 
                />
              </Form.Group>

              <Form.Group as={Col} md={4}>
                <Form.Label className="fw-semibold text-dark">Avance Personnel</Form.Label>
                <Form.Control 
                  type="text" 
                  value={advanceExpense}
                  onChange={(e) => handleNumberInput(e, setAdvanceExpense)}
                  placeholder="0.000 DT" 
                />
              </Form.Group>
            </Row>

            <Row className="g-3">
              <Form.Group as={Col} md={6}>
                <Form.Label className="fw-semibold text-dark">Achats Divers</Form.Label>
                <Form.Control 
                  type="text" 
                  value={miscExpense}
                  onChange={(e) => handleNumberInput(e, setMiscExpense)}
                  placeholder="0.000 DT" 
                />
              </Form.Group>

              <Form.Group as={Col} md={6}>
                <Form.Label className="fw-semibold text-dark">Autres Dépenses</Form.Label>
                <Form.Control 
                  type="text" 
                  value={otherExpense}
                  onChange={(e) => handleNumberInput(e, setOtherExpense)}
                  placeholder="0.000 DT" 
                />
              </Form.Group>
            </Row>
          </Card.Body>
        </Card>

        {/* 📊 SYNTHÈSE DES TOTALS - Style Bleu Lumineux Agréable */}
        <Card className="mb-4 shadow-sm border-success bg-light p-3">
          <Row className="g-3">
            <Form.Group as={Col} md={4}>
              <Form.Label className="fw-bold text-success">Montant Total Recettes</Form.Label>
              <Form.Control 
                value={`${calculateTotalAmount()} TND`}
                readOnly
                type="text" 
                className="fw-bold fs-5 text-success bg-white" 
              />
            </Form.Group>
          
            <Form.Group as={Col} md={4}>
              <Form.Label className="fw-bold text-danger">Dépenses Totales</Form.Label>
              <Form.Control 
                value={`${calculateTotalExpenses()} TND`}
                readOnly
                type="text" 
                className="fw-bold fs-5 text-danger bg-white" 
              />
            </Form.Group>

            <Form.Group as={Col} md={4}>
              <Form.Label className="fw-bold text-primary">Résultat Net (Total - Dépenses)</Form.Label>
              <Form.Control 
                value={`${(parseFloat(calculateTotalAmount()) - parseFloat(calculateTotalExpenses())).toFixed(3)} TND`}
                readOnly
                type="text" 
                className="fw-bold fs-5 text-primary bg-white" 
              />
              <Form.Text className="text-primary fw-semibold">
                Dont TPE Total: {calculateTotalTPE()} TND
              </Form.Text>
            </Form.Group>
          </Row>

          <Form.Group controlId="formExplanation" className="mt-3">
            <Form.Label className="fw-bold text-dark">Explication / Remarques</Form.Label>
            <Form.Control 
              as="textarea" 
              rows={2} 
              onChange={(e) => setExplanation(e.target.value)} 
              placeholder="Entrez vos remarques ou explications..."
            />
          </Form.Group>
        </Card>

        <Button 
          onClick={(e) => handleRapportTwin(e)} 
          variant="success" 
          type="submit" 
          className="w-100 py-3 fw-bold fs-5 shadow"
        >
          ✅ Soumettre le Rapport Twin Park
        </Button>
      </Form>
    </div>
  );
};

export default RapportsTwin;
